import type { ReactNode } from "react";
import { Modal as AriaModal, Button, Dialog, Heading } from "react-aria-components";
import "./modal.css";

interface ModalProps {
	title?: string | undefined;
	onClose?: () => void;
	show: boolean;
	children: ReactNode;
	size: "xs" | "sm" | "lg" | "md" | "xl" | "xxl" | "xxxl";
	className?: string;
	UNSTABLE_portalContainer?: Element;
}

export default function Modal({
	title = undefined,
	onClose,
	show = false,
	children,
	size,
	className,
	UNSTABLE_portalContainer,
}: ModalProps) {
	return (
		<AriaModal
			isDismissable={false}
			isOpen={show}
			onOpenChange={(nextOpen) => {
				if (!nextOpen) onClose?.();
			}}
			className={`modal ${show ? "open" : ""} ${className ?? ""}`}
			UNSTABLE_portalContainer={UNSTABLE_portalContainer}
		>
			<>
				{/*
				  RAC useInteractOutside uses the full-viewport ModalContent wrapper as the “inside” ref,
				  so dimmed-area clicks never count as outside. Portaled react-select menus on document.body
				  would also dismiss if isDismissable were true. This layer closes on backdrop click instead.
				*/}
				{show && onClose ? (
					<div
						role="presentation"
						aria-hidden
						className="modal-dismissBackdrop"
						tabIndex={-1}
						onPointerDown={(e) => {
							if (e.target !== e.currentTarget) return;
							e.preventDefault();
							onClose();
						}}
					/>
				) : null}
				<Dialog className={`ariaModal__container ariaModal__container--${size}`} aria-label={title ? title : ""}>
					{title && <Heading className="ariaModal__title">{title}</Heading>}
					{!!onClose && (
						<Button className="ariaModal-closeButton" onPress={onClose}>
							<span className="icon icon-close"></span>
						</Button>
					)}
					<div className="modal__body">{children}</div>
				</Dialog>
			</>
		</AriaModal>
	);
}
